import Container from '../Container/Container';
import Headline from '../Headline/Headline';
import Section from '../Section/Section';
import { SectionSkewBackground, SectionVariant } from '../Section/consts';
import styles from './MagazineCategoryArea.module.scss';
import type { MagazineCategoryAreaProps } from './interfaces';

const MagazineCategoryArea = ({
  headline,
  subText,
  'contents-magazine-category-teaser-area': teaserArea,
  children,
}: MagazineCategoryAreaProps) => {
  return (
    <Section
      className={styles.section}
      skewBackground={SectionSkewBackground.White}
      variant={SectionVariant.LargePadding}
      hasFullWidth
      withShadow
      noSpaceBetween
    >
      <Container>
        <div>
          <Headline className={styles.headline} subText={subText}>
            {headline}
          </Headline>

          <div className={styles.wrapper}>{teaserArea}</div>
        </div>
      </Container>

      {children}
    </Section>
  );
};

export default MagazineCategoryArea;
